import {Injectable} from "@angular/core";
import {DataService} from "../../shared/data.service";
import {ApiEndpoints} from "../../shared/ApiEndpoints";
import {of} from "rxjs";

@Injectable()
export class SyncService extends DataService{
  syncAxing() {
    return this.getRequest(ApiEndpoints.sync)
  }

  get15minDevices() {
    return this.getRequest(ApiEndpoints.sync15minDevices)
  }

  triggerSync(id, param) {
    if (!id) {
      return of({error: 'Missing device ID'})
    }
    return this.postRequest(`${ApiEndpoints.sync15minDevices}/${id}`, param)

  }
}
